import { render, staticRenderFns } from "./WisdomParam.vue?vue&type=template&id=672760ae&"
import script from "./WisdomParam.vue?vue&type=script&lang=js&"
export * from "./WisdomParam.vue?vue&type=script&lang=js&"
import style0 from "./WisdomParam.vue?vue&type=style&index=0&id=672760ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports